module.exports = __webpack_public_path__ + "static/media/login.aeee19f5.svg";